import * as React from 'react';
import { useTheme, styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import ButtonBase from '@mui/material/ButtonBase';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { useTheme, styled }, "@mui/material/Popper": Popper, "@mui/material/ClickAwayListener": ClickAwayListener, "@mui/icons-material/Settings": SettingsIcon, "@mui/icons-material/Close": CloseIcon, "@mui/icons-material/Done": DoneIcon, "@mui/material/Autocomplete": Autocomplete, "@mui/material/ButtonBase": ButtonBase, "@mui/material/InputBase": InputBase, "@mui/material/Box": Box } } });
export default ClientProvider;
